import AddFunderDialog from "@/dashboard/components/fundings/AddFunderDialog";
import React, { FC, useEffect, useState } from "react";

const FinancerInput: FC<{
  handleChange: (value) => void;
  selected?: any;
  className?: string;
  placeholder?: string;
}> = ({
  handleChange,
  selected = null,
  className = "",
  placeholder = "Commencez à taper...",
}) => {
  const [query, setQuery] = useState("");
  const [forAdd, setForAdd] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(selected);
  const [openAddFinancer, setOpenAddFinancer] = useState(false);

  useEffect(() => {
    if (query !== "") {
      setForAdd(query);
    }

    if (query.length < 3) {
      setResults([]);
      return;
    }

    const fetchResults = async () => {
      setLoading(true);
      let token = localStorage.getItem("jwtToken");
      if (token === null) {
        token = sessionStorage.getItem("jwtToken");
      }
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_ENDPOINT}/financer/search?s=${query}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        setResults(data["hydra:member"] || []);
      } catch (error) {
        console.error("Erreur lors de la récupération des résultats :", error);
        setResults([]);
      } finally {
        setLoading(false);
      }
    };

    const delayDebounceFn = setTimeout(() => {
      fetchResults();
    }, 300); // Attente de 300ms pour éviter les appels API excessifs

    return () => clearTimeout(delayDebounceFn);
  }, [query]);

  const addItem = (item) => {
    setSelectedOption(item);
    setQuery(""); // Réinitialise le champ d'entrée
    setResults([]); // Vide les résultats affichés
    handleChange(item);
  };

  useEffect(() => {
    if (openAddFinancer) {
      document.getElementById("addFinancementContent").style.opacity = "0.4";
    } else {
      document.getElementById("addFinancementContent").style.opacity = "1";
    }
  }, [openAddFinancer]);

  return (
    <>
      <div className={"mx-auto w-full " + className}>
        <input
          type="text"
          value={
            query === "" && selectedOption !== null
              ? selectedOption.fullname
              : query
          }
          onChange={(e) => {
            if (e.target.value === "") {
              setQuery("");
              setForAdd("");
              setResults([]);
              setLoading(false);
              setSelectedOption(null);
              handleChange(null);
            } else {
              setQuery(e.target.value);
            }
          }}
          onBlur={() =>
            setTimeout(() => {
              setResults([]);
              setQuery("");
            }, 200)
          }
          placeholder={placeholder}
          className="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        />
        {loading && <p className="mt-2 text-sm text-gray-500">Chargement...</p>}
        {!loading && query && (
          <ul className="posi mt-2 max-h-60 overflow-y-auto rounded-md border border-gray-300 bg-white shadow-lg">
            {/* Ajouter comme nouveau */}
            {query && (
              <li
                className="cursor-pointer border-b px-4 py-2 text-green-600 last:border-b-0 hover:bg-green-100"
                onClick={() => setOpenAddFinancer(true)}
              >
                + Ajouter <span className="font-semibold">"{query}"</span> comme
                nouveau
              </li>
            )}
            {results?.map((result, index) => (
              <li
                key={index}
                className="flex cursor-pointer gap-2 border-b px-4 py-2 last:border-b-0 hover:bg-blue-100"
                onClick={() => {
                  addItem(result);
                }}
              >
                {!result.photo && <div className="size-6"></div>}
                {result.photo && (
                  <div className="size-6">
                    <img
                      src={
                        result.photo
                          ? import.meta.env.VITE_MEDIA_BASE + result.photo.uri
                          : ""
                      }
                      alt={result.structureName}
                      height={40}
                      className="size-full object-cover"
                    />
                  </div>
                )}
                <span>{result.structureName}</span>
              </li>
            ))}
          </ul>
        )}
      </div>

      <AddFunderDialog
        hasTrigger={false}
        open={openAddFinancer}
        onHandleOpen={setOpenAddFinancer}
        onSaveSuccess={(res) => {
          addItem(res);
          setOpenAddFinancer(false);
        }}
        data={{
          name: forAdd,
        }}
      />
    </>
  );
};

export default FinancerInput;
